/**
 * @file 役務の入力フィールドを削除する
 */
'use strict';

/**
 * @classname BtnRemoveTitleField
 * @classdesc 役務の入力フィールドを削除する
 */
export default class BtnRemoveTitleField {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-remove-title-field')
	 */
	constructor($e, controller) {
		console.log('BtnRemoveTitleField.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$input = this._$e.closest('.form-group').find('input')
		this._code = this._$input.data('code');
		this._initialValue = this._$input.data('initial-value');
		this._sortableListItemIndex = this._$input.data('sortable-list-item-index');
		this._modalElement = new bootstrap.Modal(document.getElementById('modal-delete-master-maintenance-input-field'));
		this._$modal = $('#modal-delete-master-maintenance-input-field')
		this._$span = this._$modal.find('span.name');
		this._$button = this._$modal.find('.btn-delete-master-maintenance-input-field');
		this._$e.on('click', () => this.onClick());
		this._$button.on('click', () => this.onButtonClick());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnRemoveTitleField
	 * @return {undefined}
	 */
	 onClick() {
		console.log(`BtnRemoveTitleField.onClick`);
		const text = this._$e.closest('.form-group').find('input').val();
		this._$span.text(text != '' ? `「${text}」` : this._initialValue != '' ? `「${this._initialValue}」` : 'この項目');
		if(!!this._code || (!!!this._code && !!text)) {
			this._$modal.attr('data-processing-index', this._sortableListItemIndex);
			this._modalElement.show();
		} else {
			this._$e.closest('.sortable-list__item').remove();
		}
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnRemoveTitleField
	 * @return {undefined}
	 */
	onButtonClick() {
		if (Number(this._$modal.attr('data-processing-index')) !== Number(this._sortableListItemIndex)) return;
		console.log(`BtnRemoveTitleField.onButtonClick`);
		this._modalElement.hide();
		this._$e.closest('.sortable-list__item').remove();
	}
}
